module.exports = __webpack_public_path__ + "img/image_4_mobile.31eb75d.jpg";